// src/reducers/authReducer.js

import { LOGIN, LOGOUT } from '../actions/actionTypes';

const initialState = {
    kiosk_token: localStorage.getItem('kiosk_token') || null,
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            // Store the kiosk_token directly in localStorage
            localStorage.setItem('kiosk_token', action.payload);
            return { ...state, kiosk_token: action.payload };
        case LOGOUT:
            // Remove the kiosk_token from localStorage
            localStorage.removeItem('kiosk_token');
            return { ...state, kiosk_token: null };
        default:
            return state;
    }
};

export default authReducer;
